/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { FACET_ITEM_MAX_CHARACTERS, SIZE_GROUP_ID } from '../facetsListConstants';

const FacetItemWrapper = ({ checkboxClass, children, facetItem, isActive, onFacetFocus, onFacetItemClick }) => {
  return (
    <li className={`${facetItem.selected ? 'facet__item--selected' : 'facet__item'} ${checkboxClass}`}>
      <input
        type="checkbox"
        className="facet__item--checkbox"
        id={`checkbox-${facetItem.id}`}
        onClick={e => {
          onFacetItemClick(facetItem);
          e.currentTarget.blur();
        }}
        onChange={() => {}}
        checked={facetItem.selected}
        onFocus={onFacetFocus}
        tabIndex={isActive ? 0 : -1}
      />
      <label htmlFor={`checkbox-${facetItem.id}`} className={`facet__item-container ${checkboxClass}`}>
        <div className={`facet__checkbox-container ${checkboxClass}`}>{children}</div>
        <span className={`facet__info ${checkboxClass}`}>
          <span className="facet__text">{facetItem.name.slice(0, FACET_ITEM_MAX_CHARACTERS)}</span>
          {facetItem.name.length > FACET_ITEM_MAX_CHARACTERS ? '...' : ''}
          {facetItem.facet !== SIZE_GROUP_ID && <span className="facet__count">({facetItem.count})</span>}
        </span>
      </label>
    </li>
  );
};

FacetItemWrapper.defaultProps = {
  checkboxClass: '',
  onFacetFocus() {},
};

FacetItemWrapper.propTypes = {
  checkboxClass: PropTypes.string,
  children: PropTypes.element.isRequired,
  facetItem: PropTypes.shape({
    count: PropTypes.number,
    id: PropTypes.string,
    name: PropTypes.string,
    selected: PropTypes.bool,
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  onFacetFocus: PropTypes.func,
  onFacetItemClick: PropTypes.func.isRequired,
};

export default FacetItemWrapper;
